module.exports = __webpack_public_path__ + "assets/cookie-notice.e01e4c97.svg";